import API, { config } from '../API';

export const forgotPassword = (payload) => {
  const apiConf = config;
  return API.post('/user/forgotPassword', payload, apiConf);
};
